export default "__VITE_ASSET__BPc5FyI4__"